import React from 'react';
import SvgIcon48 from '../svgIcon48';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const AllCatIcon = ({ ...others }) => (
  <SvgIcon48
    title="icons / cat / all categories"
    {...others}
  >
    <g id="Group-12" transform="translate(8.000000, 8.000000)">
      <circle id="Oval-2" cx="3.5" cy="3.5" r="3.5"></circle>
      <circle id="Oval-2-Copy-3" cx="3.5" cy="16.5" r="3.5"></circle>
      <circle id="Oval-2-Copy-6" cx="3.5" cy="28.5" r="3.5"></circle>
      <circle id="Oval-2-Copy" cx="15.5" cy="3.5" r="3.5"></circle>
      <circle id="Oval-2-Copy-4" cx="15.5" cy="16.5" r="3.5"></circle>
      <circle id="Oval-2-Copy-7" cx="15.5" cy="28.5" r="3.5"></circle>
      <circle id="Oval-2-Copy-2" cx="27.5" cy="3.5" r="3.5"></circle>
      <circle id="Oval-2-Copy-5" cx="27.5" cy="16.5" r="3.5"></circle>
      <circle id="Oval-2-Copy-8" cx="27.5" cy="28.5" r="3.5"></circle>
    </g>
  </SvgIcon48>
);

export default AllCatIcon;
